import SASelect, { SelectOption, SelectProps } from './Select'

export type { SelectOption, SelectProps }
export default SASelect
